<div class="col-sm-12" id="pgmJourFerie" style="height: 100%; padding-top: 5px;">
  <div class="fiche col-sm-12" style="padding: 2px 20px 5px 20px;">
    <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
      <div class="col-sm-7 fiche-client">
        <div> Gestion des Jours Fériés </div>
      </div>
      <button class="uppercase" id="savecont" (click)="save()"> Enregistrer </button>
      <button class="uppercase btn-close" id="closeclt" (click)="showFiche()"> Fermer </button>
    </div>
  </div>
  <div class="contente ligneBon col-sm-12" style="color: #000;">
    <div class="col-sm-12" style="padding: 5px 0 0 5px">
      <mat-checkbox [color]="'primary'" [labelPosition]="'before'" (change)="checkedAll($event)"> Tout cocher
      </mat-checkbox>
    </div>
    <div class="col-sm-12 notshowQteSupp" style="padding: 5px; ">
      <ngx-datatable class="material" [rows]="listJourFerie" style="height: 100%;" [columnMode]="'force'"
        [headerHeight]="30" [footerHeight]="0" [rowHeight]="'auto'" [selectionType]="'single'"
        [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' :'Pas de tarification à afficher'}"
        [loadingIndicator]="loadingIndicator">

        <ngx-datatable-column name="quantite" prop="jourFerie.nom">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Jour Férié </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
            {{ value }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column>
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader text-center">
              <span class="uppercase"> Travailler </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div class="text-center" style="overflow: hidden;">
              <mat-checkbox class="example-margin" color="primary" [(ngModel)]="row.configJourFerie.travaillerJourFerie"
                (ngModelChange)="row.configJourFerie.rattrapageLendemain = false;"> </mat-checkbox>
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column>
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Rattrapage le Lendemain </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div class="text-center" style="overflow: hidden;">
              <mat-checkbox class="example-margin" color="primary" [disabled]="row.configJourFerie.travaillerJourFerie"
                [(ngModel)]="row.configJourFerie.rattrapageLendemain"> </mat-checkbox>
            </div>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>

  </div>
</div>